import React, { useState, useEffect } from "react";
import "./css/board.css";
import NobleSidebar from "./NobleSidebar";
import Loader from "./Loader";

const Principal = () => {
  const [principleData, setPrincipleData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/${school}/items/principle_message?fields=*.*`
        );
        const data = await response.json();
        if (data?.data?.length > 0) {
          setPrincipleData(data.data[0]);
        } else {
          setError("No data found");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("An error occurred while fetching the data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [baseUrl, school]);

  if (isLoading)
  return (
    <div className="h-[90vh] w-full flex items-center justify-center bg-white">
      <Loader />
    </div>
  );
  if (error) return <div>{error}</div>;

  const message = principleData?.principle_message || "No message available.";

  return (
    <div className="container-fluid p-0">
      <div className="container-fluid d-flex latest_card_box_ad pt-0">
        <div className="ourschoolboardeft px-3 text-left">
          <h4
            className="kalurr mt-3"
            style={{ color: "black", fontWeight: "bold" }}
          >
            Principle
          </h4>

          <div className="princd">
            <div className="photos">
              {principleData?.principle_image?.data?.full_url && (
                <img
                  src={principleData.principle_image.data.full_url.replace(
                    "http://",
                    "https://"
                  )}
                  alt="Principal"
                />
              )}
              <div className="phname ">
                Principal <b>{principleData?.principle_name || "N/A"}</b>
              </div>
            </div>

            {/*Principal Message Box */}
            <div className="director_mess bg-white shadow-md rounded-2xl p-6 mt-6 hover:shadow-xl w-full sm:w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] mx-auto">
              <h2 className="text-2xl font-bold text-gray-800 mb-3">
                Principal Message
              </h2>

              <div
                className="border border-gray-200 rounded-xl p-3 overflow-y-auto"
                style={{
                  maxHeight: "400px", 
                  width: "100%",
                  overflowY: "auto",
                  overflowX: "hidden",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                  lineHeight: "1.7",
                  fontSize: "1.1rem",
                  textAlign: "justify",
                  boxSizing: "border-box",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#cbd5e1 transparent",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: message,
                  }}
                />
              </div>
            </div>
          </div>

          {/* <p>
            <b>Dear Parents, Students, and Visitors:</b>
          </p>
          <p>
            Welcome to the Maharishi Dayanand School. As we embark on a new
            journey of growth and learning, we aim to take our school to the
            next level...
          </p>

          <p>
            Nothing can be more effective in motivating students and sustaining
            success in the school than celebrating the students'
            accomplishments...
          </p>

          <p>
            As the Maharishi Dayanand School Principal, I am more than willing
            to do all it takes to make our school an outstanding institution...
          </p>

          <p>We look forward to serving you and your children.</p>

          <p>
            Address - 243/1/2 E6 ARERA COLONY NEAR SAI BOARD BHOPAL 462016
            MADHYA PRADESH
            <br />
            Contact number - 0755-2560481
            <br />
            Email id - maharishids1986@gmail.com
          </p> */}
        </div>

        <div className="ourschoolright p-4">
          <NobleSidebar />
        </div>
      </div>
    </div>
  );
};

export default Principal;
